import "./Skeleton_module.css";
const Skeleton_module_rslib_entry_ = {
    skeleton: "skeleton-W6c63Q",
    shimmer: "shimmer-Styj7j"
};
export { Skeleton_module_rslib_entry_ as default };

//# sourceMappingURL=Skeleton.module.js.map